module.exports = __webpack_public_path__ + "static/media/side_ic_11.11d0644b.png";